import cn from 'clsx'

// Components
import { Link, Image as ResponsiveImage } from '@tracklib/kit'

// Hooks
import { useProfile } from 'modules/profile/hooks'

import styles from './avatar.css'

type ImageProps = {
  className?: string
  image: string
  sizes?: string
}
export const Image = ({ className, image, sizes = '40px' }: ImageProps): JSX.Element => (
  <ResponsiveImage className={cn(styles.avatar, className)} image={image} imageWidths={[40, 80, 160, 320]} sizes={sizes} alt="" />
)

type AvatarProps = {
  className?: string
  disabled?: boolean
  id?: string | number
  image?: string
  anonymize?: boolean
  sizes?: string
}

const Avatar = ({ className, disabled, id, image, anonymize, sizes }: AvatarProps): JSX.Element => {
  const profile = useProfile()
  const isLoggedIn = profile && profile.id !== 0
  const defaultImage = '/static/images/default-avatar.png.100x100_q85_crop.jpg'
  let userId = id
  let userImage = anonymize ? defaultImage : image || defaultImage
  const userIsAnonymous = anonymize || (!isLoggedIn && !(image || id))
  if (isLoggedIn && !(image || id)) {
    userId = profile.user
    if (profile.avatar) {
      userImage = profile.avatar
    }
  }

  if (disabled || userIsAnonymous) {
    return <Image className={className} image={userImage} sizes={sizes} />
  }

  return (
    <Link to={`/user/${userId}/`}>
      <Image className={className} image={userImage} sizes={sizes} />
    </Link>
  )
}

Avatar.Image = Image

export default Avatar
